// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"ba56373b","312":"2d363cd4","408":"f9c49963","857":"27a3888e","922":"d043095f","961":"1f7250c6"}[chunkId] + ".chunk.css";
};